import { useEffect, useState } from 'react';
import { useAppConfigContext } from '@/context/AppConfig';
import { AccessibilityIconButton } from './AccessibilityIconButton';

interface CustomWindow extends Window {
  acsbJS?: {
    init: ({
      hideMobile,
      hideTrigger,
      position,
    }: {
      hideMobile: boolean;
      hideTrigger: boolean;
      position: string;
    }) => void;
  };
}

const ACCESSIBILITY_URL = 'https://acsbapp.com/apps/app/assets/js/acsb.js';

export const AccessibilityWidget = () => {
  const [loaded, setLoaded] = useState(false);
  const { logError } = useAppConfigContext();

  const loadScript = () => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = ACCESSIBILITY_URL;

      const el = document.getElementsByTagName('script')[0];
      el.parentNode?.insertBefore(script, el);
      script.addEventListener('load', () => {
        setLoaded(true);
        resolve(script);
      });

      script.addEventListener('error', () => {
        reject(new Error(`${ACCESSIBILITY_URL} failed to load.`));
      });
    });
  };

  const load = async () => {
    if (!loaded) {
      try {
        await loadScript();
        (window as CustomWindow).acsbJS?.init({
          hideMobile: false,
          hideTrigger: true,
          position: 'left',
        });
      } catch (e: unknown) {
        if (e instanceof Error) {
          logError('Error loading accessibility script', e);
        }
      }
    } else {
      (window as CustomWindow).acsbJS?.init({
        hideMobile: false,
        hideTrigger: true,
        position: 'left',
      });
    }
  };

  useEffect(() => {
    load();
  }, []);

  return <AccessibilityIconButton />;
};
